import { isAudioLineItem } from './AudioLineItem';
import { isTranscriptLineItem } from './CertifiedTranscriptLineItem';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isPriceCalculationInput(input) {
    const assumedType = input;
    return assumedType.type !== undefined && assumedType.timeRanges !== undefined;
}
export function toPriceCalculationInput(lineItem) {
    return {
        type: lineItem.type,
        timeRanges: toTimeRanges(lineItem),
        turnaroundId: isTranscriptLineItem(lineItem) ? lineItem.turnaroundId : undefined,
        paperCopies: isTranscriptLineItem(lineItem) ? lineItem.paperCopies : undefined,
        speechToTextAdded: isAudioLineItem(lineItem) ? lineItem.speechToTextAdded : false,
    };
}
export function toTimeRanges(lineItem) {
    return lineItem.hearingSegments.map(segment => segment.timeRange);
}
